import React from 'react';
import { createRoot } from 'react-dom/client';
import { PlatformProvider } from './context/PlatformContext';
import { AuthProvider } from './context/authContext';
import { FirebaseProvider } from './context/firebaseContext';
import App from './App';
import './assets/all.sass';

// Strip console logs in production
import './utils/logger';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <FirebaseProvider>
        <PlatformProvider>
          <App />
        </PlatformProvider>
      </FirebaseProvider>
    </AuthProvider>
  </React.StrictMode>
);
